import { render } from "./Index.vue?vue&type=template&id=5f71e162&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=5f71e162&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5f71e162"

export default script